import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { auth, db } from "../../firebaseconfig"; // Correção do caminho
import { doc, getDoc } from "firebase/firestore";
import "./Perfil.css";

const Perfil = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;
      if (user) {
        const userDocRef = doc(db, "usuarios", user.uid); // Verifique se a coleção é "usuarios"
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const data = userDoc.data();
          // Converter Timestamps para strings
          data.dataCadastro = data.dataCadastro ? data.dataCadastro.toDate().toLocaleString("pt-BR") : "Não informado";
          data.ultimaAtualizacao = data.ultimaAtualizacao ? data.ultimaAtualizacao.toDate().toLocaleString("pt-BR") : "Não informado";
          setUserData(data);
        }
      }
      setLoading(false);
    };
    fetchUserData();
  }, []);

  if (loading) return <div className="loading">Carregando...</div>;

  return (
    <div className="perfil-container">
      <h1>Perfil</h1>
      {userData ? (
        <div className="perfil-content">
          <p><strong>Nome Completo:</strong> {userData.nomeCompleto || "Não informado"}</p>
          <p><strong>Email:</strong> {userData.email || "Não informado"}</p>
          <p><strong>CPF:</strong> {userData.cpf || "Não informado"}</p>
          <p><strong>Data de Cadastro:</strong> {userData.dataCadastro}</p>
          <p><strong>Última Atualização:</strong> {userData.ultimaAtualizacao}</p>
          <p><strong>Premium:</strong> {userData.premium ? "Sim" : "Não"}</p>
          <div className="app-status">
            <p><strong>Apps Ativos:</strong></p>
            <ul>
              <li>CalcAgro: {userData.calcagro ? "Ativo" : "Inativo"}</li>
              <li>CalcBov: {userData.calcbov ? "Ativo" : "Inativo"}</li>
              <li>CalcCafé: {userData.calccafe ? "Ativo" : "Inativo"}</li>
              <li>CalcLeite: {userData.calcleite ? "Ativo" : "Inativo"}</li>
            </ul>
          </div>
          <Link to="/conta" className="account-link">Gerenciar Conta</Link>
        </div>
      ) : (
        <p>Nenhum dado de usuário encontrado.</p>
      )}
    </div>
  );
};

export default Perfil;